import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button';
import { TranslationNamespace } from 'i18n';

// Redirect-type ecom providers (e.g. manypay) complete on their own hosted gateway. We send the customer
// there automatically and keep a visible button as a fallback for when the auto-redirect is blocked.
type Props = {
  paymentLink: string;
};

export const EcomRedirect: React.FC<Props> = ({ paymentLink }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.ecom_redirect',
  });

  useEffect(() => {
    window.location.assign(paymentLink);
  }, [paymentLink]);

  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-3 md:tw-gap-4">
      <h3 className="tw-text-lg tw-font-bold tw-text-primary md:tw-text-2xl">
        {t('title')}
      </h3>
      <p className="tw-text-secondary">{t('hint')}</p>
      <Button
        className="tw-mt-2"
        onClick={() => window.location.assign(paymentLink)}
      >
        {t('submit')}
      </Button>
    </div>
  );
};
